import React from "react";
import {Badge, Card, CardBody, Col, Container, Row} from "shards-react";
import PageTitle from "../components/common/PageTitle";
import hit from './../utils/Hits';
import OWN_GAMES from './../data/ownGames';
import tankyLogo from "./../images/tanky.png";

class TankyPage extends React.Component {


    constructor() {
        super();

        this.openTanky = this.openTanky.bind(this);
    }


    openTanky() {
      hit(OWN_GAMES.TANKY);
      window.open(`https://hernizona.online/tanky/?session=${Math.random()}`, "_blank");
    }

    componentDidMount() {
      this.openTanky();
    }

    render() {
        return (
            <Container fluid className="main-content-container px-4">
                <Row noGutters className="page-header py-4">
                    <PageTitle sm="4" title="Hra Tanky" subtitle="Hry"
                               className="text-sm-left"/>
                </Row>

                <Row>
                    <Col lg="3" md="6" sm="12" className="mb-4" key={'tanky2026'}>
                        <Card small className="card-post card-post--1">
                            <div
                                className="card-post__image"
                                style={{
                                    backgroundImage: `url(${tankyLogo})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                    backgroundSize: 'contain',
                                    minHeight: '15rem'
                                }}
                            >
                                <Badge
                                    pill
                                    className={`card-post__category bg-dark`}
                                >
                                    hodnocení 5
                                </Badge>
                            </div>
                            <CardBody>
                                <h5 className="card-title" onClick={this.openTanky}>
                    <span className="text-fiord-blue">
                      Tanky
                    </span>
                                    &nbsp;&nbsp;&nbsp;
                                    <span style={{float: 'right'}}
                                          className="mb-2 mr-1 btn btn-success">
                      Hrát
                    </span>
                                </h5>

                            </CardBody>
                        </Card>
                    </Col>

                </Row>


            </Container>
        );
    }
}

export default TankyPage;
